/* eslint-disable no-restricted-globals */
import React, { useState, useRef } from 'react';

import { useHistory } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
  Button, InputGroup,
} from 'reactstrap';
// import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { del, post } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import AddressingForm from '../../components/TVs/AddressingForm';
import PalletLabelsForm from '../../components/TVs/PalletLabelsForm';

function TVLabels(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const history = useHistory();

  const [signal, setSignal] = useState(0);
  const [sortModalOpen, setSortModalOpen] = useState(false);

  const qtyRef = useRef(null);
  const laneRef = useRef(null);
  document.title = t('TV Labels');

  const deleteAddressing = async (obj) => {
    // eslint-disable-next-line no-alert
    if (confirm(t('Are you sure you want to delete this addressing?'))) {
      await del(`/api/tvs/addressing/${obj.id}`);
      setSignal(signal + 1);
    }
  };

  const printLabels = async () => {
    const qty = qtyRef.current.value || 100;

    try {
      await post('/api/tvs/addressing/print', { qty });
    } catch (error) {
      toastr.error(t('Error printing labels'), t('Error'));
    }
  };

  const printLaneLabels = async () => {
    const lanes = laneRef.current.value || '';

    window.open(`/tvs/lane-labels?lanes=${lanes}`, '_blank');
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="5">
            <Card>
              <CardHeader className="border-bottom bg-transparent">
                {t('Pre-Print Sort Labels (SJNs)')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="TVs">
                  <Row>
                    <Col sm="6">
                      <InputGroup>
                        <input type="number" ref={qtyRef} placeholder="100" className="form-control" />
                        <Button color="primary" onClick={printLabels}>
                          <span className="mdi mdi-printer" />
                        </Button>
                      </InputGroup>
                    </Col>
                  </Row>
                </Can>

                <Can not i="see" this="TVs"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="border-bottom bg-transparent">
                {t('SJN Addressing')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="TVs">
                  <BaseGrid
                    url="/api/tvs/addressing"
                    hasSearch={false}
                    shouldUpdate={signal}
                    create={() => { setSortModalOpen(true); }}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                        },
                        truck: {
                          label: 'Truck',
                          format: (value) => (value ? value.reference : 'N/A'),
                          link: {
                            to: '/sourcing/truck/%truck_id%',
                          },
                        },
                        order: {
                          label: 'Order',
                          format: (value) => (value ? value.id : 'N/A'),
                          link: {
                            to: '/sourcing/order/%order_id%',
                          },
                        },
                        start: {
                          label: 'Start',
                          format: (value) => value.toString(36).toUpperCase(),
                        },
                        end: {
                          label: 'End',
                          format: (value) => value.toString(36).toUpperCase(),
                        },

                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'delete',
                              icon: 'mdi mdi-trash-can',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Delete'),
                              click: deleteAddressing,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="TVs"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardHeader className="border-bottom bg-transparent">
                {t('Lane Labels')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="TVs">
                  <Row>
                    <Col sm="6">
                      <InputGroup>
                        <input type="text" ref={laneRef} placeholder="A.1,A.2" className="form-control" />
                        <Button color="primary" onClick={printLaneLabels}>
                          <span className="mdi mdi-printer" />
                        </Button>
                      </InputGroup>
                      <div className="text-muted mt-2">{t('Comma separated lanes')}</div>
                    </Col>
                  </Row>
                </Can>

                <Can not i="see" this="TVs"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="border-bottom bg-transparent">{t('Pre-Print Pallet Labels')}</CardHeader>
              <CardBody>
                <Row>
                  <Col xl="6">
                    <PalletLabelsForm onSuccess={(pallets) => { history.push('/tvs/pallet-labels', { pallets }); }} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          size="lg"
          isOpen={sortModalOpen}
        >
          <div className="modal-header">
            <h5
              className="modal-title mt-0"
            >
              {t('Addressing')}
            </h5>
            <button
              onClick={() => setSortModalOpen(false)}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <AddressingForm
              entity={{}}
              onSuccess={() => { setSortModalOpen(false); setSignal(signal + 1); }}
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setSortModalOpen(false)}
              className="btn btn-soft-dark"
              data-dismiss="modal"
            >
              {t('Cancel')}
            </button>
            <button
              type="submit"
              form="AddressingForm"
              className="btn btn-primary"
            >
              {t('Save')}
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
}

TVLabels.defaultProps = {
  t: (x) => (x),
};

TVLabels.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVLabels));
